

























































export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-user/index.vue"
}
